import { createApp } from 'vue'
import NykTag from './NykTag.vue'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps'

const el = '.nyk-component--nyk-tag'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((nykTagDOM) => {
            const props = handleComponentProps(NykTag, nykTagDOM) || {}
            const component = createApp(NykTag, props).use(Store)
            component.mount(nykTagDOM)
        })
    }
}
